/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrinterDto
 */
export interface PrinterDto {
    /**
     * Printer name
     * @type {string}
     * @memberof PrinterDto
     */
    name: string;
    /**
     * Printer server name
     * @type {string}
     * @memberof PrinterDto
     */
    serverName: string;
}

/**
 * Check if a given object implements the PrinterDto interface.
 */
export function instanceOfPrinterDto(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('serverName' in value)) return false;
    return true;
}

export function PrinterDtoFromJSON(json: any): PrinterDto {
    return PrinterDtoFromJSONTyped(json, false);
}

export function PrinterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrinterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'serverName': json['serverName'],
    };
}

export function PrinterDtoToJSON(value?: PrinterDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'serverName': value['serverName'],
    };
}

